import { Dispatch } from 'redux'
import { SECTOR_ERROR, SECTOR_LOADED, SECTOR_LOADING } from '../slices/sectorSlice'
import { NeoniApi, RequestOptions } from '../../lib/api'
import { getApiErrorMessage } from '../../lib/utils'

export const getSectors = (api: NeoniApi, options?: RequestOptions) => async (dispatch: Dispatch) => {
	dispatch({
		type: SECTOR_LOADING,
	})

	try {
		const body = await api.get(`sectors/`, options)
		if (options?.signal?.aborted) return

		if (body.success === true && Array.isArray(body.sectors)) {
			// Successfully fetched purchases
			dispatch({
				type: SECTOR_LOADED,
				payload: body.sectors,
			})
		} else {
			// Error
			dispatch({
				type: SECTOR_ERROR,
				payload: getApiErrorMessage({ body }, 'Could not load sectors. Please try again.'),
			})
		}
	} catch (error) {
		if (options?.signal?.aborted) return
		dispatch({
			type: SECTOR_ERROR,
			payload: getApiErrorMessage(error, 'Could not load sectors. Please try again.'),
		})
	}
}
